module.exports = __webpack_public_path__ + "static/media/heart-full-no-outline.e7b74e9d.svg";